module.exports = __webpack_public_path__ + "img/florian-kowol-1.23b182fc.jpg";